import { Severity, addBreadcrumb } from '@sentry/browser';
import { cookieNames } from 'src/constants/cookieNames';
import { eraseCookie, setCookie } from 'src/utils/Cookies';
import { Environment } from 'src/utils/Environment';

const growthApiClient = Environment.current.growthApiClient;
const growthPartnerApiUrl = '/growth/partner/v1';

const clearMerchantInfoCookies = () => {
  eraseCookie(cookieNames.INTEGRATION_TOKEN);
  eraseCookie(cookieNames.INTEGRATION_HASDATA);
  eraseCookie(cookieNames.REFERRER_PHONE);
  eraseCookie(cookieNames.SALESFORCE_ID);
  eraseCookie(cookieNames.REFERRER);
  eraseCookie(cookieNames.REFERRAL_TYPE);
};

export const retrieveAndSetMerchantInfo = async (userLinkToken: string) => {
  try {
    clearMerchantInfoCookies();
    const merchantInfo = await growthApiClient.get(`${growthPartnerApiUrl}/clients/${userLinkToken}/verification`);
    if (!merchantInfo.data || !merchantInfo.data.isValid) {
      throw new Error('Merchant Info invalid');
    }
    setMerchantInfoCookies(merchantInfo, userLinkToken);
    if (merchantInfo.data.hasMerchantData && merchantInfo.data.referralType && merchantInfo.data.referralType === 'BC') {
      await retrieveBcReferralInfo(userLinkToken, false);
    }
  } catch (err) {
    addBreadcrumbToSentry(err);
    clearMerchantInfoCookies();
  }
};

export const retrieveBcReferralInfo = async (userLinkToken: string, isFormPrefill: boolean) => {
  try {
    const response = await growthApiClient.get(`${growthPartnerApiUrl}/referral?client=${userLinkToken}`);
    return setBcReferralCookiesWhenNonPrefill(response, isFormPrefill);
  } catch (err) {
    addBreadcrumbToSentry(err);
    eraseCookie(cookieNames.REFERRER_PHONE);
    eraseCookie(cookieNames.SALESFORCE_ID);
    eraseCookie(cookieNames.REFERRER);
  }
};

const setMerchantInfoCookies = (response: any, userLinkToken: string) => {
  if (!response || !response.data) return;
  setCookie(cookieNames.INTEGRATION_TOKEN, userLinkToken, 2);
  setCookie(cookieNames.INTEGRATION_HASDATA, response.data.hasMerchantData, 2);
  setCookie(cookieNames.REFERRAL_TYPE, response.data.referralType, 2);
};

const setBcReferralCookiesWhenNonPrefill = (response: any, isFormPrefill: boolean) => {
  if (!response.data) {
    throw new Error('BC Referral Info invalid');
  }
  if (isFormPrefill) {
    return response.data;
  }

  setCookie(cookieNames.REFERRER_PHONE, response.data.referrer.phoneNumber, 2);
  setCookie(cookieNames.SALESFORCE_ID, response.data.salesforceId, 2);
  const referrerObject = { ...response.data.referrer };
  delete referrerObject.phoneNumber;
  setCookie(cookieNames.REFERRER, JSON.stringify(referrerObject), 2);
};

const addBreadcrumbToSentry = (error: Error) => {
  addBreadcrumb({
    category: 'cookies',
    message: `Coudn't set up the cookies due to ${error}`,
    level: Severity.Error,
    type: 'error',
  });
};
